<div [hidden]="!ViewReady" fxLayout="column" fxLayoutAlign="start stretch">
    <h2 class="mat-headline">Referrals Needing Action</h2>
    <div>
        The following requests have been returned by the assigned responders and are in need of facilitator action. You may click on
        the "View" button to view the details of the responder's response, and to take appropriate actions for handling the response.
    </div>
    <table
        class="fullwidth"
        *ngIf="SearchConducted"
        mat-table
        [dataSource]="ActionNeededRequestsData"
        matSort
        matSortActive="RequestPriority"
        matSortDirection="asc"
    >
        <ng-container matColumnDef="RequestIssueNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Request #</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.RequestIssueNumber | requestIssue: req.FiscalYear }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="BoardMember">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Board Member</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.RequestorInfo?.FirstName | titleCase }} {{ req.RequestorInfo?.LastName | titleCase }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DateNeeded">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Due</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span *ngIf="req.DateNeeded">{{ req.DateNeeded | date: 'M/d/yyyy' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="Priority">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Priority</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.PriorityShortLabel || '' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="Subject">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Subject</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.Subject }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="CategoryLabel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Category</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <div>{{ req.CategoryLabel }}</div>
                <div>({{ req.CategoryID | categoryCabinet: Categories }})</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Status</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span>{{ req.Status | referralStatus: false:req.Completed }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="ReferredToFullName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Referred To</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span [attr.title]="'SAPID: ' + req.ReferredTo" *ngIf="req.ReferredTo">{{ req.ReferredToFullName }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DateCreated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Opened</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <span *ngIf="IsLargeOrWider">{{ req.DateCreated | date: 'M/d/yyyy' }}</span>
                <span *ngIf="!IsLargeOrWider">{{ req.DateCreated | date: 'M/d/yy' }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Actions</th>
            <td mat-cell *matCellDef="let req" class="centered">
                <button type="button" mat-raised-button color="accent" (click)="HandleEdit(req)">View</button>
            </td>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let req" [attr.colspan]="VisibleHeaders?.length">
                <em>There are currently no referrals awaiting action at this time.</em>
            </td>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <th mat-header-cell *matHeaderCellDef>Referrals Needing Action</th>
            <td mat-cell *matCellDef="let req">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <strong>Request #</strong> <span>{{ req.RequestIssueNumber | requestIssue: req.FiscalYear }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <app-form-label>Board Member</app-form-label>
                        <span>{{ req.RequestorInfo?.FirstName | titleCase }} {{ req.RequestorInfo?.LastName | titleCase }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <strong>Due</strong> <span *ngIf="req.DateNeeded">{{ req.DateNeeded | date: 'M/d/yyyy' }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <strong>Priority</strong> <span>{{ req.PriorityShortLabel || '' }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <strong>Subject</strong> <span>{{ req.Subject }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <strong>Category</strong>
                        <div fxLayout="column" fxLayoutAlign="start end">
                            <div>{{ req.CategoryLabel }}</div>
                            <div>({{ req.CategoryID | categoryCabinet: Categories }})</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <strong>Status</strong> <span>{{ req.Status | referralStatus: false:req.Completed }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <strong>Referred To</strong>
                        <span [attr.title]="'SAPID: ' + req.ReferredTo" *ngIf="req.ReferredTo">{{ req.ReferredToFullName }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <strong>Opened</strong> <span *ngIf="IsLargeOrWider">{{ req.DateCreated | date: 'M/d/yyyy' }}</span>
                        <span *ngIf="!IsLargeOrWider">{{ req.DateCreated | date: 'M/d/yy' }}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center start" class="margin-bottom">
                        <button type="button" mat-raised-button color="accent" (click)="HandleEdit(req)">View</button>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="VisibleHeaders"></tr>
        <tr mat-row *matRowDef="let row; columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></tr>
    </table>

    <mat-paginator
        #paginator
        [length]="ActionNeededRequestsData?.data?.length"
        [pageIndex]="0"
        [pageSize]="SmallDisplay ? 5 : 10"
        [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
</div>
